import DOMPurify from 'dompurify';

const sanitize = (html) => {
  if (typeof window === 'undefined') return html;
  return DOMPurify.sanitize(html);
};

export default sanitize;
